// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { UserProgressProvider } from "./context/UserProgressContext";
import { DarkModeProvider } from "./context/DarkModeProvider";
import { LanguageProvider } from "context/LanguageProvider";
import { PremiumProvider } from "context/PremiumProvider";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "./assets/css/SidebarComponents/Quiz.css";
import "./assets/css/language-fonts.css";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import HomePageView from "views/HomePageView.js";
import StagePageView from "views/StagePageView.js";
import GeneralStage from "views/examples/GeneralStage";
import GamesPage from "layouts/GamesLayout";
import GameField from "views/examples/GameField";
import ProgrammingPageView from "views/ProgrammingPageView";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <UserProgressProvider>
    <PremiumProvider>
      <DarkModeProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin/*" element={<AdminLayout />} />
              <Route path="/auth/*" element={<AuthLayout />} />
              <Route path="/HomePage/homepage" element={<HomePageView />} />
              <Route path="/structure/:structureName/:substructureId" element={<StagePageView />} />
              <Route path="/admin/programming/:language" element={<ProgrammingPageView />} />
              <Route path="/general" element={<GeneralStage />} />
              <Route path="/games" element={<GamesPage />} />
              <Route path="/gameFiled/*" element={<GameField />} />
              <Route path="*" element={<Navigate to="/auth/login" replace />} />
            </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </DarkModeProvider>
    </PremiumProvider>
  </UserProgressProvider>
);